// src/screens/sales/order/Order.tsx

import React from 'react'
import classes from './Order.module.sass'
import { Helmet } from 'react-helmet-async'
import { List } from './components/list/List'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import { useOrder } from './hooks/useOrder'
import Qr from '../../../common/components/qr/Qr'
import { Button } from '../../../common/components/button/Button'
import { selectConnected } from '../../../store/slices/wsSlice'
import Search from '../../../common/components/listControl/search/Search'
import { useSearchWithDebounce } from '../../../common/hooks/useSearchWithDebounce'
import { useSelector } from 'react-redux'

export const Order = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    onReadQr,
    initialData,
    startCreate,
    loading,
  } = useOrder()

  const isConnected = useSelector(selectConnected)

  const {
    searchQuery,
    handleSearch,
    clearSearch,
    filteredItems: filteredList,
  } = useSearchWithDebounce({
    items: list,
    searchFields: ['orderNumber', 'phone_number', 'user.phone_number', 'id'],
  })

  return (
    <div className={classes.container}>
      <Helmet>
        <title>{`Заказы`}</title>
        <meta name="description" content={`Заказы`} />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>{`заказы`}</div>
        <Button onClick={startCreate} text="Создать" disabled={!isConnected} />
        <Qr onChange={onReadQr} />
      </div>

      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по номеру, телефону или ID"
        />
      </div>

      <List showDetails={showDetails} startEdit={startEdit} list={filteredList} loading={loading} />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
          initialData={initialData}
          modalActive={modalActive}
        />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} onEdit={startEdit} />
      </Modal>
    </div>
  )
}
